<template>
  <v-data-table :headers="getHeaders" :items="listadoAnticipos">
    <template v-slot:[`item.fecha`] = "{ item }">
      {{ $moment(item.fecha).format('DD/MM/YYYY') }}
    </template>
    <template v-slot:[`item.porcentaje`]="{ item }">
      <v-chip> {{ item.porcentaje }}% </v-chip>
    </template>
    <template v-slot:[`item.importe`]="{ item }">
      {{ item.importe | currency }}
    </template>
    <template v-slot:[`item.importeInicioTrabajos`]="{ item }">
      {{ item.importeInicioTrabajos | currency }}
    </template>
    <template v-slot:[`item.importeCostoFinanciamiento`]="{ item }">
      {{ item.importeCostoFinanciamiento | currency }}
    </template>
    <template v-slot:[`item.iva`]="{ item }">
      {{ item.iva | currency }}
    </template>
    <template v-slot:[`item.total`]="{ item }">
      {{ item.total | currency }}
    </template>
    <template v-slot:[`item.solicitudPago`]="{ item }">
      <estatus-pago
        :solicitud="item.solicitudPago">
      </estatus-pago>
    </template>
    <template v-slot:[`item.createdAt`]="{ item }">
      <fecha-humano :fecha="item.createdAt"> </fecha-humano>
    </template>
    <template v-if="!soloLectura" v-slot:[`item.acciones`]="{ item }">
      <v-tooltip top
      v-if="mixValidaScopesActions(2)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip top
      v-if="mixValidaScopesActions(3)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';
import EstatusPago from '@/components/administracion/pagos/EstatusPago.vue';

export default {
  name: 'ListadoAnticiposContratoDesktop',
  props: {
    listadoAnticipos: {
      type: Array,
      required: true,
    },
    esContratoFinanciado: {
      type: Boolean,
      required: false,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    FechaHumano,
    EstatusPago,
  },
  data() {
    return {
      headers: [
        {
          text: 'Fecha',
          align: 'start',
          sortable: false,
          value: 'fecha',
        },
        { text: 'Porcentaje', value: 'porcentaje' },
        { text: 'Importe', value: 'importe', align: 'end' },
        { text: 'I.V.A', value: 'iva', align: 'end' },
        { text: 'Total', value: 'total', align: 'end' },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: 'Pagado', value: 'solicitudPago', align: 'center', sortable: false,
        },
        {
          text: '',
          align: 'end',
          width: '150',
          value: 'acciones',
        },
      ],
      idContrato: this.$route.params.idContrato,
    };
  },
  methods: {
    editar(anticipoContrato) {
      eventBus.$emit('editar-anticipo-contrato', anticipoContrato);
    },
    borrar(anticipoContrato) {
      eventBus.$emit('eliminar-anticipo-contrato', anticipoContrato);
    },
  },
  computed: {
    getHeaders() {
      if (this.esContratoFinanciado) {
        return [
          {
            text: 'Fecha',
            align: 'start',
            sortable: false,
            value: 'fecha',
          },
          { text: 'Porcentaje', value: 'porcentaje' },
          { text: 'Inicio Trabajos', value: 'importeInicioTrabajos', align: 'end' },
          { text: 'Costo Financiamiento', value: 'importeCostoFinanciamiento', align: 'end' },
          { text: 'Importe', value: 'importe', align: 'end' },
          { text: 'I.V.A', value: 'iva', align: 'end' },
          { text: 'Total', value: 'total', align: 'end' },
          { text: 'F. Registro', value: 'createdAt' },
          {
            text: 'Pagado', value: 'solicitudPago', align: 'center', sortable: false,
          },
          {
            text: '',
            align: 'end',
            width: '150',
            value: 'acciones',
          },
        ];
      }

      return this.headers;
    },
  },
};
</script>

<style lang="scss">
</style>
